import { AttributeInput } from "services/interface";
import styled from "@emotion/styled";
import { FormInstance, Row } from "antd";
import { FC, useEffect, useState } from "react";
import ProductAtributteCard from "./ProductAttributeCard";
import ProductCategoryCard from "./ProductCategoryCard";
import ProductDescriptionForm from "./ProductDescriptionForm";
import ProductImageCard from "./ProductImageCard";
import ProductNameForm from "./ProductNameForm";
//import ProductVariationCard from "./ProductVariationCard";
import ProductSKUCard from "./ProductSKUCard";
import ProductRecommendForm from "./ProductRecommendForm";
//import ProductOpenSaleForm from "./ProductOpenSale";
import ProductRetailTypeCard from "./ProductRetailTypeCard";
import ProductIsRecommend from "./ProductIsRecommend";
import ProductTagname from "./ProductTagname";

import ProductSGImportantAdviceForm from "./ProductSGImportantAdviceForm";
import ProductSGRecommendedShop from "./ProductSGRecommendedShop";
import ProductSGFrequentlyQnA from "./ProductSGFrequentlyQnA";
import ProductSGSalesIncome from "./ProductSGSalesIncome";
import ProductSGInviteSale from "./ProductSGInviteSale";
import ProductSGWaitingTime from "./ProductSGWaitingTime";

import { useAppSelector } from "store";

import type { UploadFile } from "antd/es/upload/interface";

interface MainCreateProductProps {
  form: FormInstance;
  onFinish: (values: any) => void;
  attribute: AttributeInput[];
  setAttribute: (attribute: AttributeInput[]) => void;
  setVariants: (variants: VariantsInput) => void;
  variants: VariantsInput;
  prices: PricesInput;
  setPrices: (prices: PricesInput) => void;
  setCheckIsActive: (checkIsActive: boolean) => void;
  checkIsActive: boolean;
  setCheckIsRecommend: (checkIsRecommend: boolean) => void;
  checkIsRecommend: boolean;
  setCheckIsApproved: (checkIsApproved: boolean) => void;
  checkIsApproved: boolean;
  setCheckIsShowApp: (checkIsShowApp: boolean) => void;
  checkIsShowApp: boolean;
}

const MainCreateProduct: FC<MainCreateProductProps> = ({
  form,
  attribute,
  setAttribute,
  setVariants,
  variants,
  prices,
  setPrices,
  checkIsActive,
  setCheckIsActive,
  checkIsRecommend,
  setCheckIsRecommend,
  checkIsApproved,
  setCheckIsApproved,
  checkIsShowApp,
  setCheckIsShowApp,
}) => {
  const [skuImage, setSkuImage] = useState<UploadFile[] | undefined>([]);
  useEffect(() => {
    console.log("🔄 skuImageM:", skuImage);
  }, [skuImage]);

  const { contact } = useAppSelector((state) => state.auth);
  const factoryId = contact?.id;

  // ✅ useEffect สำหรับตรวจสอบและปิดการขายอัตโนมัติใน Create Mode
  useEffect(() => {
    // ปิดการขายอัตโนมัติเมื่อไม่มี SKU เลย หรือ SKU ทุกรายการเป็น inactive
    // (กันกรณีเปิดการขายไว้แล้วลบ SKU ทั้งหมด ทำให้ปุ่มบันทึกค้าง disabled โดยไม่มีสาเหตุ)
    const allSKUsInactive = variants.every(variant =>
      variant.items.every(item => item.is_active === false)
    );

    if (allSKUsInactive && checkIsActive) {
      setCheckIsActive(false);
      // ✅ ตั้งค่า form field is_active เป็น false
      form.setFieldValue("is_active", false);
    }
  }, [variants, checkIsActive, setCheckIsActive, form]);

  return (
    <FormWrapper>
      <ProductImageCard is_active={checkIsActive} setCheckIsActive={setCheckIsActive} variants={variants} />

      <FormItemWrapper style={{ paddingTop: 10 }}>
        <ProductNameForm is_active={true} />
      </FormItemWrapper>
      <FormItemWrapper style={{ padding: 0 }}>
        <Row gutter={[16, 16]} style={{ backgroundColor: "#EFEFEFEF" }}>
          <ProductCategoryCard is_active={checkIsActive} />
          <ProductRetailTypeCard is_active={checkIsActive} />
        </Row>
      </FormItemWrapper>
      <FormItemWrapper>
        {/* <ProductOpenSaleForm setCheckIsActive={setCheckIsActive} /> */}

        {/* ระบบเก่า - ProductVariationCard 
          <ProductVariationCard
            setVariants={setVariants}
            variants={variants}
            prices={prices}
            setPrices={setPrices}
          />
          */}
        {/* tabs สินค้า/คลัง อยู่ใน header ของ ProductSKUCard แล้ว */}
        <ProductSKUCard
          setVariants={setVariants}
          variants={variants}
          prices={prices}
          setPrices={setPrices}
          skuImage={skuImage}
          setSkuImage={setSkuImage}
          form={form}
          factoryId={factoryId}
        />

        {/*สินค้าแนะนำ / สินค้าค้างสต๊อก*/}
        <div style={{ height: 10 }}></div>
        <ProductIsRecommend
          is_recommend={checkIsRecommend}
          setCheckIsRecommend={setCheckIsRecommend}
          checkIsActive={checkIsActive}
          setCheckIsActive={setCheckIsActive}
          checkIsApproved={checkIsApproved}
          setCheckIsApproved={setCheckIsApproved}
          checkIsShowApp={checkIsShowApp}
          setCheckIsShowApp={setCheckIsShowApp}
        />

        {/*เครื่องมือสื่อสาร (Media Kit)*/}
        <ProductRecommendForm />

        {/*คำแนะนำสำคัญ*/}
        <ProductSGImportantAdviceForm is_active={true} />

        <ProductDescriptionForm is_active={true} />

        {/*ระยะเวลารอรับสินค้า*/}
        <ProductSGWaitingTime is_active={true} />

        {/*แนะนำร้านค้าเป้าหมาย*/}
        <ProductSGRecommendedShop is_active={true} />
        {/*คำถามที่พบบ่อยเกี่ยวกับตัวสินค้า*/}
        <ProductSGFrequentlyQnA is_active={true} />
        {/*กำไรและราคาแนะนำ (Business Guide) – ช่วยให้ตัวแทนวางแผนได้*/}
        <ProductSGSalesIncome is_active={true} />

        {/*แผนสร้างการซื้อซ้ำ (Repeat Plan) – วิธีทำให้ลูกค้ากลับมาซื้ออีก*/}
        <ProductSGInviteSale is_active={true} />
     

      </FormItemWrapper>
      {/* <ProductImageDesCard /> */}
      <FormItemWrapper style={{ paddingBottom: 20 }}>
        <Row gutter={[16, 16]} style={{ backgroundColor: "#EFEFEFEF" }}>
          {/*quickwin*/}
          {contact?.code === "lunganek" && (
            <ProductTagname />
          )}

          {contact?.code === "lunganek" && (
            <ProductAtributteCard
              attribute={attribute}
              setAttribute={setAttribute}
            />
          )}

        </Row>
      </FormItemWrapper>
    </FormWrapper>
  );
};

export default MainCreateProduct;

const FormWrapper = styled.div`
  width: 100%;
  height: 100%;
  background-color: #efefefef;
`;

const FormItemWrapper = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 10px;
`;
